export default "__VITE_ASSET__f8f8101e__"